import { React, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HeaderB from "../Header/HeaderB";
import GoBackLink from "../GoBacklink/GoBackLink";
import ProductThumbNailGroup from "../ProductThumbNailGroup/ProductThumbNailGroup";
import AddToCartB from "../AddToCart/AddToCartB";
import BestGear from "../BestGear/BestGear";
// Interlude start
import marktwo from "../../assets/shared/desktop/image-xx99-mark-two-headphones.jpg";

import speaker from "../../assets/shared/desktop/image-zx9-speaker.jpg";
import speakerTab from "../../assets/shared/tablet/image-zx9-speaker.jpg";
import speakerMobile from "../../assets/shared/mobile/image-zx9-speaker.jpg";
import xx59 from "../../assets/shared/desktop/image-xx59-headphones.jpg";
import xx59Tab from "../../assets/shared/tablet/image-xx59-headphones.jpg";
import xx59Mobile from "../../assets/shared/mobile/image-xx59-headphones.jpg";

// Interlude end

import AlsoLike from "../AlsoLike/AlsoLike";

import Footer from "../Footer/Footer";
import Features from "../Features/Features";
import markOne from "../../assets/shared/desktop/image-xx99-mark-one-headphones.jpg";
import markOneTab from "../../assets/shared/tablet/image-xx99-mark-one-headphones.jpg";
import markOneMobile from "../../assets/shared/mobile/image-xx99-mark-one-headphones.jpg";
import speakerzx9Img from "../../assets/shared/desktop/image-zx9-speaker.jpg";
import speakerzx9Tab from "../../assets/shared/tablet/image-zx9-speaker.jpg";
import speakerZx9Mobile from "../../assets/shared/mobile/image-zx9-speaker.jpg";

import xx59Img from "../../assets/shared/desktop/image-xx59-headphones.jpg";
import xx59ImgTab from "../../assets/shared/tablet/image-xx59-headphones.jpg";
import xx59ImgMobile from "../../assets/shared/mobile/image-xx59-headphones.jpg";
import speakerzx7Img from "../../assets/product-zx7-speaker/desktop/image-product.jpg";
import speakerzx7ImgTab from "../../assets/product-zx7-speaker/tablet/image-product.jpg";
import speakerzx7ImgMobile from "../../assets/product-zx7-speaker/mobile/image-product.jpg";
import ProductGallery from "../ProductGallery/ProductGallery";
import imgGallery1 from "../../assets/product-zx7-speaker/desktop/image-gallery-1.jpg";
import imgGallery2 from "../../assets/product-zx7-speaker/desktop/image-gallery-2.jpg";
import imgGallery3 from "../../assets/product-zx7-speaker/desktop/image-gallery-3.jpg";

const SpeakerZx7 = ({
  addZx7ToCart,
  cart,
  updateMyCart,
  updateQuantity,
  increment,
  decrement,
  quantity,
}) => {
  const params = useParams();
  const [imgUrl, setImgURL] = useState("");
  const [markOneUrl, setMarkOneURL] = useState("");
  const [speakerzx9Url, setSpeakerzx9URL] = useState("");
  const [xx59Url, setxx59URL] = useState("");
  useEffect(() => {
    const handleResize = () => {
      console.log("Resizing...");
      if (window.innerWidth <= 450) {
        console.log("Resizing for SpeakerZx7.jsx mobile view");
        setImgURL(speakerzx7ImgMobile);
        setMarkOneURL(markOneMobile);
        setSpeakerzx9URL(speakerZx9Mobile);
        setxx59URL(xx59ImgMobile);
      } else if (window.innerWidth <= 768) {
        console.log("Resizing for SpeakerZx7.jsx tablet view");
        setImgURL(speakerzx7ImgTab);
        setMarkOneURL(markOneTab);
        setSpeakerzx9URL(speakerzx9Tab);
        setxx59URL(xx59ImgTab);
      } else {
        console.log("Resizing for SpeakerZx7.jsx desktop view");

        setImgURL(speakerzx7Img);
        setMarkOneURL(markOne);
        setSpeakerzx9URL(speakerzx9Img);
        setxx59URL(xx59Img);
      }

      console.log("Resize in Progress");
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <HeaderB
        cart={cart}
        updateCartQuantity={updateQuantity}
        increment={increment}
        decrement={decrement}
        quantity={quantity}
      />
      <main>
        <GoBackLink prevPage={"/speakers"} />
        <AddToCartB
          imageURL={imgUrl}
          productName={
            <>
              ZX7
              <br /> Speaker
            </>
          }
          description="Stream high quality sound wirelessly with minimal to no loss. The ZX7 speaker uses high-end
  audiophile components that represents the top of the line powered speakers for home or studio use."
          price="3500"
          addItem={updateMyCart}
          updateQuantity={updateQuantity}
          quantity={quantity}
          increment={increment}
          decrement={decrement}
        />
        <Features
          p1="Reap the advantages of a flat diaphragm tweeter cone. This provides a fast response rate and 
          excellent high frequencies that lower tiered bookshelf speakers cannot provide. The woofers are made 
          from aluminum that produces a unique and clear sound. XLR inputs allow you to connect to a mixer for 
          more advanced usage."
          p2=" The ZX7 speaker is the perfect blend of stylish design and high performance. It houses an encased MDF 
          wooden enclosure which minimises acoustic resonance. Dual connectivity allows pairing through bluetooth 
          or traditional optical and RCA input. Switch input sources and control volume at your finger tips with 
          the included wireless remote. This versatile speaker is equipped to deliver an authentic listening experience."
        />
        <ProductGallery image={[imgGallery1, imgGallery2, imgGallery3]} />
        <AlsoLike
          image={[speakerzx9Url, markOneUrl, xx59Url]}
          title={["ZX9 SPEAKER", "XX99 MARK I", "XX59"]}
          nav1={"/speakerZx9"}
          nav2={"/headphones/markOne"}
          nav3={"/headphones/xx59"}
        />
        <ProductThumbNailGroup />
        <BestGear />
        <Footer />
      </main>
    </>
  );
};

export default SpeakerZx7;
